export function RestaurantInfoDirective(googleAnalyticsService, restaurantService) {
    'ngInject';
    return {
        restrict: 'E',
        replace: false,
        compile: function(templateElem, templateAttrs) {
            const guid = templateAttrs.guid;
            const name = templateAttrs.name;
            const info = JSON.parse(templateAttrs.info).info;
            const diningOptions = JSON.parse(templateAttrs.diningOptions);

            ['guid', 'name', 'info', 'diningOptions'].forEach(key => {
                templateElem.removeAttr(key);
                Reflect.deleteProperty(templateAttrs, key);
            });

            googleAnalyticsService.setName(name);
            restaurantService.setRestaurantData(guid, name, info, diningOptions);
        }
    };
}
